import { useFpCampaignCartCalculate } from '@cart-services/hooks/useFpCampaignCartCalculate'
import { useFpCampaignCartStore } from '@cart-services/hooks/useFpCampaignCartStore'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { PaymentMethodType } from '@hooks-api/types/dataModel/payment'
import { useTranslation } from 'react-i18next'
import { useCampaign } from '../hooks/use-campaign'
import style from '../style/components/checkout-progress.module.scss'

interface CheckoutProgressProps {
  currentStep: number
  isCounterCheckoutEnabled?: boolean
  // NOTE: thank you page 的購物車 store 已經被清空，所以需要 props
  shouldShowCounterProps?: boolean
}

const CheckoutProgress = ({ currentStep, shouldShowCounterProps }: CheckoutProgressProps) => {
  const { t } = useTranslation()
  const { campaignCodeFromUrl } = useCampaign()
  const { destructuredData: exhibitorSettings } = useApiCampaignActivityInfo(campaignCodeFromUrl)
  const [cartValues] = useFpCampaignCartStore(exhibitorSettings?.campaign_id ?? null)
  const { destructuredData: campaignCalculateData } = useFpCampaignCartCalculate(exhibitorSettings?.campaign_id ?? null, campaignCodeFromUrl)
  const paymentMethods = campaignCalculateData?.payment_methods
  const offlinePaymentId = paymentMethods?.find(payment => payment.type === PaymentMethodType.OFFLINE_PAYMENT)?.id
  const isOfflinePayment = cartValues.payment.appliedPaymentMethodId === offlinePaymentId
  const shouldShowCounter = !cartValues.isGiveawayDispatch || isOfflinePayment
  const indicatorsAllCheckoutStages = [t('global.shippingInformation'), t('progressBar.paymentMethods'), t('progressBar.goToTheCounter'), t('global.orderCompleted')]
  const indicatorsNoCounter = [t('global.shippingInformation'), t('progressBar.paymentMethods'), t('global.orderCompleted')]
  const indicators = (shouldShowCounter || shouldShowCounterProps) ? indicatorsAllCheckoutStages : indicatorsNoCounter
  const totalSteps = indicators.length
  const currentProgress = `${Math.min(100, (currentStep - 1) / (totalSteps - 1) * 100)}%`

  return (
    <div className={style.wrapper}>
      <div className={style['progress-bar']}>
        {/* Iterate over the total number of steps to create points dynamically */}
        {Array.from({ length: totalSteps }, (_, i) => (
          <div
            key={i}
            className={`${style.point} ${currentStep > i ? style.active : ''}`}
            style={{
              left: `${(i / (totalSteps - 1) * 100)}%`,
            }}
          >
            {indicators[i]}
          </div>
        ))}
        <div className={style.progress} style={{ width: currentProgress }} />
      </div>
    </div>
  )
}

export default CheckoutProgress
